const longformRow = {
  key: 'longformRow',
  componentKey: 'row',
  label: 'Longform row'
};

export default longformRow;
